import { DataTableColumnHeader } from '@/components/shadcn/data-table'
import { ColumnDef } from '@tanstack/react-table'
import moment from 'moment'

type HistoryType = {
  id: number
  created_at: string
  updated_at: string
  score: number
  summary: string
  image_url: string
  ad_url: string
  landing_page_url: string
  ad_image_url: string
  landing_page_image_url: string
}

export const historyColumns: ColumnDef<HistoryType>[] = [
  {
    accessorKey: 'customer_number',
    size: 70,
    header: ({ column }) => <DataTableColumnHeader column={column} title="Item" />,
  },
  {
    accessorKey: 'created_at',
    header: ({ column }) => <DataTableColumnHeader column={column} title="Date" />,
    cell: (params) => moment(params.row.getValue('created_at')).format('lll'),
  },
  {
    accessorKey: 'name',
    header: ({ column }) => <DataTableColumnHeader column={column} title="Name" />,
  },
  {
    accessorKey: 'customer_segment',
    header: ({ column }) => <DataTableColumnHeader column={column} title="Segment" />,
  },
  {
    accessorKey: 'email',
    header: ({ column }) => <DataTableColumnHeader column={column} title="Email" />,
  },
  {
    accessorKey: 'phone',
    header: ({ column }) => <DataTableColumnHeader column={column} title="Phone" />,
  },
]
